import { createAction } from '@reduxjs/toolkit';
import { HighlightCard } from '@yleisradio/areena-types';

export const clearViewDataById = createAction<string>(
  'viewData/clearViewDataById'
);

export const clearViewDataList = createAction<{
  viewId: string;
  tabIndex: number;
  listIndex: number;
}>('viewData/clearViewDataList');

export const clearContinueListsAction = createAction(
  'viewData/clearContinueList'
);

export const clearFavoriteListsAction = createAction(
  'viewData/clearFavoriteList'
);

export const clearViewData = createAction('viewData/clearViewData');

export const addHighlightCard = createAction<{
  highlightCard: HighlightCard;
  viewId: string;
  tabIndex: number;
  listIndex: number;
}>('viewData/addHighlightCard');
